export default "__VITE_ASSET__H_UuaBad__"